import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { GenerateResumeData } from './resume.interface';
import { PublicResumeService } from './resume.service';

const service = new PublicResumeService();

export interface PublicResumeState {}

const PublicResumeStore: Module<PublicResumeState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async generateResume(context, generateResumeData: GenerateResumeData) {
         const response = await service.generateResume(generateResumeData);
         return response;
      },
   },
};

export default PublicResumeStore;
